import { getMessageCount, getMessageList, messageRead } from "@/api";

export function isRejectMessage(item) {
  if (!item) return false;
  const title = String(item.title || "");
  if (title.includes("审批驳回")) return true;
  const type = item.type ?? item.msgType ?? item.messageType;
  return type === "审批驳回";
}

function isUnread(item) {
  return item && Number(item.isRead) !== 1;
}

const state = {
  count: 0,
  list: [],
};

const getters = {
  unreadRejectMessages: (storeState) =>
    (storeState.list || []).filter((item) => isUnread(item) && isRejectMessage(item)),
  hasUnreadReject: (storeState, storeGetters) => storeGetters.unreadRejectMessages.length > 0,
};

const mutations = {
  SET_MESSAGE_COUNT(storeState, count) {
    storeState.count = Number(count) || 0;
  },
  SET_MESSAGE_LIST(storeState, list) {
    storeState.list = Array.isArray(list) ? list : [];
  },
  SET_MESSAGE_READ(storeState, id) {
    storeState.list = storeState.list.map((item) =>
      item.id === id ? { ...item, isRead: 1 } : item
    );
  },
};

const actions = {
  async fetchMessageCount({ commit }) {
    const result = await getMessageCount();
    if (result && result.code === 200) {
      commit("SET_MESSAGE_COUNT", result.data);
      return;
    }
    commit("SET_MESSAGE_COUNT", 0);
  },
  async fetchMessageList({ commit }) {
    const res = await getMessageList();
    if (res && res.code === 200) {
      commit("SET_MESSAGE_LIST", res.data);
      return;
    }
    commit("SET_MESSAGE_LIST", []);
  },
  async markMessageRead({ commit, dispatch }, id) {
    await messageRead(id);
    commit("SET_MESSAGE_READ", id);
    await dispatch("fetchMessageCount");
  },
  async markRejectMessagesRead({ getters, commit, dispatch }) {
    const list = getters.unreadRejectMessages;
    if (!list.length) return;
    for (const item of list) {
      try {
        await messageRead(item.id);
        commit("SET_MESSAGE_READ", item.id);
      } catch (error) {
        console.log(error);
      }
    }
    await dispatch("fetchMessageCount");
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
